import { IconButton } from "@material-ui/core"
import Div100vh from "react-div-100vh"
import Arrows from "../../../components/Icons/Arrows"
import {
  Content,
  Holder,
  BackButton,
  LeftHolder,
  MiddleHolder,
  RightHolder,
  LeftPic,
  LeftBottomHolder,
  TaylorPic,
  Text1,
  Text2,
  Divider,
  MiddleTopHolder,
  MiddleBottomHolder,
  CaptionHolder,
  Text3,
  Text4
} from "./Makers.style.js"
import TaylorIcon from "./taylor.svg"
import StarIcon from "./star.svg"
import StarsIcon from "./stars.svg"
import { AboutPath } from "../../../routes"

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  ease: "easeIn",
  duration: 0.7
}

function Makers() {
  return (
    <Div100vh>
      <Holder
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
      >
        <Content>
          <LeftHolder>
            <LeftPic />
            <LeftBottomHolder>
              <TaylorPic src={TaylorIcon} />
              <div>
                <Text3>Not all hosuebuilders are equal.</Text3>
                <Text4>New Homes as they should be.</Text4>
              </div>
              <Divider />
              <Text1>
                AT TAYLOR WIMPEY, WE KNOW HOW IMPORTANT YOUR NEW HOME IS
              </Text1>
              <Text2>
                Taylor Wimpey UK, part of Taylor Wimpey plc, is one of the
                largest residential developers in the UK. It operates from 24
                regional offices across England, Scotland and Wales, and builds
                over 14,500 homes every year.
              </Text2>
            </LeftBottomHolder>
          </LeftHolder>
          <MiddleHolder>
            <MiddleTopHolder>
              <Text1>WE OFFER DEDICATED CUSTOMER SERVICE</Text1>
              <Text2 style={{ marginBottom: "2rem" }}>
                From people who really care. We are committed to helping you
                find your perfect home so you can enjoy a stress-free move. We
                have a team of experts who are always on hand to help make your
                home buying journey easy and answer all your questions.
              </Text2>
              <Text1>YOU CAN TRUST OUR INDUSTRY LEADING QUALITY</Text1>
              <Text2>
                We're proud to have been awarded 5 stars for customer
                satisfaction by the Home Builders Federation, which means over
                90% of customers would recommend us to a friend.* 
              </Text2>
              <div style={{ display: "flex", margin: "1rem 0" }}>
                <img
                  src={StarIcon}
                  style={{ marginRight: "1rem" }}
                  alt=""
                ></img>
                <Text2>
                  We're proud to have been awarded 5 stars for customer
                  satisfaction by the Home Builders Federation, which means over
                  90% of customers would recommend us to a friend.* 
                </Text2>
              </div>
            </MiddleTopHolder>
            <MiddleBottomHolder>
              <Text1>DON’T JUST TAKE OUR WORD FOR IT</Text1>
              <Text2>
                We welcome customers feedback to help us do the best job
                possible. We're so confident in our service that we welcome
                Trustpilot reviews from all customers. Listening to your
                feedback and making sure you're happy help us to improve our
                service and allows us to continue leading the industry.
              </Text2>
              <img
                src={StarsIcon}
                style={{ margin: "1rem 0 4rem 0", width: "18rem" }}
                alt=""
              ></img>
              <CaptionHolder>
                When we're building your home,{" "}
                <span style={{ color: "#96323D" }}>
                  we never forget we're building your future.
                </span>{" "}
                And we take this responsibility very seriously.
              </CaptionHolder>
            </MiddleBottomHolder>
          </MiddleHolder>
          <RightHolder />
        </Content>
        <BackButton to={AboutPath}>
          <IconButton>
            <Arrows flip={1} />
          </IconButton>
        </BackButton>
      </Holder>
    </Div100vh>
  )
}

export default Makers
